module.exports = __webpack_public_path__ + "img/footer-left-ctas-cjdr.0560689a.png";